import React from 'react';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { columns } from '../tanStackColumns';

const AcompanhamentosTable = ({
  data,
  onRowClick,
  loading,
  manualPagination = false,
  totalRegistros = 0,
  pagination,
  onPaginationChange
}) => {
  return <TanStackTable columns={columns()} data={data} onRowClick={onRowClick} isSortable={true} withPagination={true} pageSizeOptions={[5, 10, 25, 50, 100]} enableRowColors={false} loading={loading} className="mt-3" style={{
    cursor: 'pointer'
  }} manualPagination={manualPagination} totalItems={totalRegistros} controlledPagination={{
    pageIndex: pagination?.pageIndex || 0,
    pageSize: pagination?.pageSize || 5
  }} onPaginationChange={onPaginationChange} />;
};

export default AcompanhamentosTable;
